import React from 'react';
import { Image } from 'antd';
const ImageComp = ({source}) => (
  <Image
   
    src={source}
    className="h-full w-full object-cover object-center group-hover:opacity-75"
  />
);
export default ImageComp;